var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mask-side-section-container",
    { attrs: { title: _vm.sectionTitle } },
    [
      _c(
        "v-flex",
        {
          staticClass: "scroll-fire-fox",
          staticStyle: { height: "100%", overflow: "auto" }
        },
        _vm._l(_vm.ductEntryTypes, function(ductEntryType) {
          return _vm.ductEntryTypes.length > 0
            ? _c(
                "div",
                { key: ductEntryType.code },
                [
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "btn py-2",
                      class: {
                        selected: ductEntryType === _vm.selectedDuctEntryType
                      },
                      attrs: {
                        row: "",
                        "align-center": "",
                        "justify-space-around": ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleDuctEntryOption(ductEntryType)
                        }
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs7: "" } },
                        [
                          _c("duct-entry-shape", {
                            attrs: {
                              shape: ductEntryType.shape,
                              width: ductEntryType.width,
                              height: ductEntryType.height
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs5: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c("v-flex", [
                                _vm._v(_vm._s(ductEntryType.libelle))
                              ]),
                              _vm._v(" "),
                              _c("v-flex", [
                                _vm._v(_vm._s(ductEntryType.size))
                              ]),
                              _vm._v(" "),
                              _c("v-flex", [
                                _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(ductEntryType.containerWidth) +
                                      " x\n                " +
                                      _vm._s(ductEntryType.containerHeight) +
                                      "\n              "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6be6033f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6033f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntriesSelector.vue
// module id = null
// module chunks = 